export default __webpack_public_path__ + "static/media/fasting_planing.c71615f5.jpg";